import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import SignIn from "@/pages/auth/SignIn";
import SignUp from "@/pages/auth/SignUp";
import VerifyEmail from "@/pages/auth/VerifyEmail";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import AppShell from "@/pages/app/AppShell";
import { PaymentSuccess, PaymentCancel } from "@/pages/app/Payments";
import AdminReviewQueue from "@/pages/admin/AdminReviewQueue";
import Landing from "@/pages/Landing";
import PilotTerms from "@/pages/PilotTerms";
import { Toaster } from "@/components/ui/sonner";
import ActionScreen from "@/pages/app/ActionScreen";
import { TeamAccept } from "@/pages/app/Team";
import { AdminSubscribers, AdminHealth } from "@/pages/admin/AdminOps";
import AdminTrusteeHelp from "@/pages/admin/AdminTrusteeHelp";
import { AdminMarketPrices, AdminExchangeRates, AdminVendors } from "@/pages/admin/AdminMarket";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminShell from "@/pages/admin/AdminShell";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAdmins from "@/pages/admin/AdminAdmins";
import AdminAuditLog from "@/pages/admin/AdminAuditLog";
import AdminEmails from "@/pages/admin/AdminEmails";

const SubscriberRoutes = () => (
  <AuthProvider>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pilot-terms" element={<PilotTerms />} />
      <Route path="/act" element={<ActionScreen />} />
      <Route path="/team/accept" element={<TeamAccept />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/verify" element={<VerifyEmail />} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/app/*" element={<AppShell />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="*" element={<Navigate to="/signin" replace />} />
    </Routes>
  </AuthProvider>
);

const AdminRoutes = () => (
  <AdminAuthProvider>
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route path="forgot" element={<ForgotPassword admin />} />
      <Route path="reset" element={<ResetPassword admin />} />
      <Route element={<AdminShell />}>
        <Route index element={<AdminOverview />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="review-queue" element={<AdminReviewQueue />} />
        <Route path="trustee-help" element={<AdminTrusteeHelp />} />
        <Route path="market-prices" element={<AdminMarketPrices />} />
        <Route path="exchange-rates" element={<AdminExchangeRates />} />
        <Route path="vendors" element={<AdminVendors />} />
        <Route path="subscribers" element={<AdminSubscribers />} />
        <Route path="health" element={<AdminHealth />} />
        <Route path="admins" element={<AdminAdmins />} />
        <Route path="audit" element={<AdminAuditLog />} />
        <Route path="emails" element={<AdminEmails />} />
      </Route>
    </Routes>
  </AdminAuthProvider>
);

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-center" richColors closeButton />
      <Routes>
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/*" element={<SubscriberRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}
